'use client';

import { useState, useEffect } from 'react';
import FooterServer from './FooterServer';

const FooterClient = () => {
  const [currentLanguage, setCurrentLanguage] = useState<'en' | 'de'>('en');

  useEffect(() => {
    const savedLanguage = localStorage.getItem('preferredLanguage') as 'en' | 'de' | null;
    if (savedLanguage && (savedLanguage === 'en' || savedLanguage === 'de')) {
      setCurrentLanguage(savedLanguage);
    }

    const handleLanguageChange = (event: CustomEvent<{ language: 'en' | 'de' }>) => {
      setCurrentLanguage(event.detail.language);
    };

    window.addEventListener('languageChange', handleLanguageChange as EventListener);
    return () => {
      window.removeEventListener('languageChange', handleLanguageChange as EventListener);
    };
  }, []);

  return <FooterServer currentLanguage={currentLanguage} />;
};

export default FooterClient;